<template>
  <div>
    <div class="numberdiv" v-if="show" ref="numberdiv">
      <InputNumber
        style="width: 80px"
        size="small"
        :border="false"
        v-model="start"
        :min="0"
      ></InputNumber>
      至
      <InputNumber
        style="width: 80px"
        size="small"
        :border="false"
        :min="0"
        v-model="end"
      ></InputNumber>
    </div>

    <Input
      v-if="!show"
      size="small"
      :border="false"
      v-model="atob"
      @on-focus="open"
      readonly
    ></Input>
  </div>
</template>
<script>
export default {
  props: ["atob", "readonly"],
  data() {
    return {
      start: 0,
      end: 0,
      show: false,
    };
  },
  methods: {
    open() {
      if (this.readonly) {
        return false;
      }
      this.show = true;
      var t = this.atob.split("-");

      this.start = Number(t[0]);
      this.end = Number(t[1]);
    },
    fuzhi() {
      this.show = false;
      this.$emit("aaa", this.start + "-" + this.end);
    },
  },
  model: {
    prop: "atob",
    event: "aaa",
  },
  mounted() {
    window.addEventListener("mousedown", (e) => {
      var odiv = this.$refs.numberdiv;
      if (!odiv) {
        return;
      }
      var m = odiv.getBoundingClientRect();
      if (m.x == 0 && m.y == 0) {
        return;
      }
      if (
        !(
          e.x >= m.left &&
          e.x <= m.right &&
          e.y >= m.top - 20 &&
          e.y <= m.bottom
        )
      ) {
        this.fuzhi();
        //console.log("在外面");
      }
    });
  },
};
</script>
<style>
.numberdiv {
  width: 200px;
  border: solid 2px red;
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/baojia/startAndend.vue